import React, { FC } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { InlineHelp } from '../../../components';
import { useTranslation } from '../../../translations';
import { Fetcher, useFetcher } from '../../../utils';
import { surchargeRateText } from '../surcharges/utils';

export const PlatformInfoSettings: FC = () => {
  const { ts } = useTranslation();
  const fetcher = useFetcher(async () => await api.getPlatformFees());

  if (!fetcher.success) {
    return <Fetcher result={fetcher} />;
  }

  const regFee = fetcher.data.find(({ name }) => name === 'platform-fee-registration');
  const otherFee = fetcher.data.find(({ name }) => name === 'platform-fee-other');

  return (
    <>
      <h3>{ts('platform_info')}</h3>
      <br />
      <Row>
        <Col className="mb-10" lg={4} xs={12}>
          <Card>
            <CardBody>
              {ts('these_fees_are_charged_by_concat')}
              <br />
              <br />
              {ts('by_default_our_platform_fees_are_absorbed')}
            </CardBody>
          </Card>
        </Col>
        <Col xs={12} />
        <Col className="mb-10" lg={2} xs={12}>
          <Card id="platformFeeRegistration">
            <CardBody>
              <p>
                {ts('per_registration_platform_fee')}
                <InlineHelp>{ts('this_is_the_fee_charged')}</InlineHelp>
              </p>
              <h3>{surchargeRateText(regFee!)}</h3>
            </CardBody>
          </Card>
        </Col>
        <Col lg={2} xs={12}>
          <Card id="platformFeeOther">
            <CardBody>
              <p>
                {ts('other_product_platform_fee')}
                <InlineHelp>{ts('this_is_the_fee_charged')}</InlineHelp>
              </p>
              <h3>{surchargeRateText(otherFee!)}</h3>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};
